/**
 * @type {Object}
 * @property {array}  data  Product data
 */
const initialState = {
    addresses: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerAddresses = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_ADDRESSES':
            var { data } = action;
            newState.addresses = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerAddresses;